/**
 * @file 비품 예약 API
 * 비품(카탈로그)·카테고리·보관위치 관리 + 예약 CRUD + 캘린더 조회.
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const B = `${API_BASE}/equipment`;

export const equipmentApi = {
    // ─── 카테고리 ────────────────────────────────────────────────
    getCategories: (includeInactive = false) => api.get(`${B}/categories`, { includeInactive }),
    createCategory: (data)     => api.post(`${B}/categories`, data),
    updateCategory: (id, data) => api.put(`${B}/categories/${id}`, data),
    deleteCategory: (id)       => api.delete(`${B}/categories/${id}`),

    // ─── 보관위치 ────────────────────────────────────────────────
    getLocations: (includeInactive = false) => api.get(`${B}/locations`, { includeInactive }),
    createLocation: (data)     => api.post(`${B}/locations`, data),
    updateLocation: (id, data) => api.put(`${B}/locations/${id}`, data),
    deleteLocation: (id)       => api.delete(`${B}/locations/${id}`),

    // ─── 비품 ────────────────────────────────────────────────────
    getEquipment: (includeInactive = false) => api.get(`${B}/items`, { includeInactive }),
    createEquipment: (data)     => api.post(`${B}/items`, data),
    updateEquipment: (id, data) => api.put(`${B}/items/${id}`, data),
    deleteEquipment: (id)       => api.delete(`${B}/items/${id}`),

    // ─── 참조 데이터 (부서·프로젝트 채널·현재 사용자) ────────────
    getDepartments: () => api.get(`${API_BASE}/employees/departments`),
    getChannels:    () => api.get(`${API_BASE}/channel/list`),
    getMe:          () => api.get(`${API_BASE}/employees/me`),

    // ─── 예약 ────────────────────────────────────────────────────
    getReservations: ()         => api.get(`${B}/reservations`),
    getReservationCalendar: (from, to) => api.get(`${B}/reservations/calendar`, { from, to }),
    getAvailability: (equipmentId, from, to, excludeId) =>
        api.get(`${B}/reservations/availability`,
            { equipmentId, from, to, ...(excludeId ? { excludeId } : {}) }),
    createReservation: (data)     => api.post(`${B}/reservations`, data),
    createReservationGroup: (data) => api.post(`${B}/reservations/group`, data),  // 여러 비품 한 번에
    updateReservation: (id, data) => api.put(`${B}/reservations/${id}`, data),
    deleteReservation: (id)       => api.delete(`${B}/reservations/${id}`),
    returnReservation: (id)       => api.post(`${B}/reservations/${id}/return`),  // 항목 반납 처리
    // ─── 예약건(그룹) 단위 ────────────────────────────────────────
    updateReservationGroup: (groupId, data) => api.put(`${B}/reservations/group/${groupId}`, data),   // 공통 헤더·메모 수정
    deleteReservationGroup: (groupId)       => api.delete(`${B}/reservations/group/${groupId}`),      // 예약건 전체 삭제
    returnReservationGroup: (groupId)       => api.post(`${B}/reservations/group/${groupId}/return`), // 예약건 전체 반납
};
